'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('answers-view', {
		props: ['answers', 'answered'],
		template: 
		'<div class="survey-answers">' +
			'<div class="survey-answers-container">' +
				'<div class="answer" v-for="answer in answers">' +
					'<button class="btn btn-primary" v-on:click="answered(answer.weight)">{{answer.weight}}</button>' +
					'<span>{{answer.label}}</span>' +
				'</div>' +
			'</div>' +
		'</div>',
	});
});
